module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".md",".mdx"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1400}},{"resolve":"gatsby-remark-prismjs","options":{"aliases":{"sh":"bash","dosini":"ini"}}},"gatsby-remark-copy-linked-files"],"rehypePlugins":[null]},
    }]
